var _symbol, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoscope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32.074px",
    height: "32.074px",
    viewBox: "0 0 32.074 32.074",
    enableBackground: "new 0 0 32.074 32.074",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "dude-transit",
    viewBox: "0 -25.1 21.25 25.118"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M15.5-4.2l0.75-1.05l1-3.1l3.9-2.65v-0.05 c0.067-0.1,0.1-0.233,0.1-0.4c0-0.2-0.05-0.383-0.15-0.55c-0.167-0.233-0.383-0.35-0.65-0.35l-4.3,1.8l-1.2,1.65l-1.5-3.95 l2.25-5.05l-3.25-6.9c-0.267-0.2-0.633-0.3-1.1-0.3c-0.3,0-0.55,0.15-0.75,0.45c-0.1,0.133-0.15,0.25-0.15,0.35 c0,0.067,0.017,0.15,0.05,0.25c0.033,0.1,0.067,0.184,0.1,0.25l2.55,5.6L10.7-14l-3.05-4.9L0.8-18.7 c-0.367,0.033-0.6,0.184-0.7,0.45c-0.067,0.3-0.1,0.467-0.1,0.5c0,0.5,0.2,0.767,0.6,0.8l5.7,0.15l2.15,5.4l3.1,5.65L9.4-5.6 c-1.367-2-2.1-3.033-2.2-3.1C7.1-8.8,6.95-8.85,6.75-8.85C6.35-8.85,6.1-8.667,6-8.3C5.9-8,5.9-7.8,6-7.7H5.95l2.5,4.4l3.7,0.3 L14-3.5L15.5-4.2z M14.55-2.9c-0.333,0.4-0.45,0.85-0.35,1.35c0.033,0.5,0.25,0.9,0.65,1.2c0.4,0.3,0.85,0.417,1.35,0.35 c0.5-0.067,0.9-0.3,1.2-0.7c0.333-0.4,0.467-0.85,0.4-1.35c-0.066-0.5-0.3-0.9-0.7-1.2c-0.4-0.333-0.85-0.45-1.35-0.35 C15.25-3.533,14.85-3.3,14.55-2.9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M27.366,15.763c-0.083,1.883-0.603,3.655-1.495,5.194l0.726,0.735c1.144-1.875,1.803-4.077,1.803-6.429 c0-6.829-5.557-12.385-12.386-12.385c-2.343,0-4.535,0.654-6.406,1.788l0.73,0.73c1.535-0.886,3.3-1.402,5.176-1.485l1-0.008 c5.879,0.257,10.603,4.982,10.86,10.859L27.366,15.763z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "26.406,15.763 20.7,15.763 19.69,14.763 26.395,14.763  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "16.514,4.874 16.514,11.549 15.514,10.598 15.514,4.874  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "5.611,15.763 12.443,15.763 11.448,14.763 5.622,14.763  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M16.514,26.615c1.907-0.084,3.699-0.616,5.252-1.529l0.728,0.728c-1.886,1.163-4.106,1.834-6.48,1.834 c-6.829,0-12.386-5.557-12.386-12.386c0-2.371,0.67-4.589,1.83-6.474L6.173,9.54c-0.903,1.546-1.429,3.328-1.512,5.223l-0.008,1 c0.257,5.879,4.982,10.603,10.86,10.86L16.514,26.615z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "16.514,25.647 16.514,19.806 15.514,18.841 15.514,25.647  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.022,
    y: -1.261,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 -6.0247 15.7014)",
    fill: "#FFFFFF",
    width: 3.827,
    height: 32.765
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "topo"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoscope);
export default __webpack_public_path__ + "static/media/noscope.30d4dd670fb1ae05eeae1e1ad861def9.svg";
export { ForwardRef as ReactComponent };